import axios from 'axios';
import { SYSTEMDOX_API_URL } from '@/lib/apiConfig';

const api = axios.create({ baseURL: SYSTEMDOX_API_URL });

export interface SkillFile {
  /** Repo-relative path, e.g. `skills/systemdox-checks-auth/SKILL.md`. */
  path: string;
  content: string;
}

export interface SkillsExportResult {
  files: SkillFile[];
  count: number;
  generatedAt: string;
}

export const skillsExportApi = {
  setAuthProvider(getToken: () => Promise<string | null>) {
    api.interceptors.request.use(async (config) => {
      const token = await getToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  },

  /**
   * Generate the workspace's Standards as a portable Agent Skills (SKILL.md)
   * bundle. Space-scoped server-side: only Standards the caller can read are
   * included.
   */
  async export(): Promise<SkillsExportResult> {
    const { data } = await api.get('/standards/skills-export');
    return data;
  },
};
